module.exports = __webpack_public_path__ + "img/bk.5d82e28d.jpg";